const directions: any = {
    'ascend': 'asc',
    'descend': 'desc'
}

const getSortBy = (key: string, direction: string) => {
    return `${key} ${directions[direction]}`
}

export default getSortBy